import { css } from "@emotion/react";
import { SPACING } from "~/styles/variables";

const tableStyle = css`
  margin-top: ${SPACING.SMALL};
`;

const caseDetailsHeaderStyle = css`
  height: 100%;
`;

export default {
  tableStyle,
  caseDetailsHeaderStyle,
};
